import { useEffect, useState } from "react";

interface MobileState {
    isMobileHeader: boolean | null;
}

const useHeaderMobileDetect = (): MobileState => {
    const [isMobileHeader, setIsMobileHeader] = useState<boolean | null>(null);

    useEffect(() => {
        if (typeof window !== undefined) {
            const handleResize = () => {

                const mobile = window.innerWidth < 1199; // Example threshold for mobile devices
                setIsMobileHeader(mobile);
            };

            // Set initial state on component mount
            handleResize();

            // Add event listener for window resize
            window.addEventListener("resize", handleResize);

            // Remove event listener on component unmount
            return () => window.removeEventListener("resize", handleResize);
        }
    }, []); // Empty dependency array to run only on mount and unmount

    return { isMobileHeader };
};

export default useHeaderMobileDetect;
